<template>
	<div class="message-tip">
		<div class="wakeup-success-wrap">
			<img
				src="../assets/home/node/close.png"
				class="close-btn"
				@click="closeClick"
			/>
			<div class="wakeup-success-icon"></div>
			<div class="wakeup-success-title">已下发开机指令</div>
			<div class="wakeup-success-tips">
				如需帮助，可查看<span @click="showWakeupTips">开机指引</span>
			</div>
			<div class="done-btn" @click="closeClick">确 定</div>
		</div>
	</div>
</template>

<script>
import Message from "./Message.vue";

export default {
	components: {
		Message,
	},
	props: {
		messageType: String,
	},
	data: function () {
		return {
			installNasFlag: true, //默认true显示安装nas弹框
			installNasQhFlag: false, //true显示群晖插件弹框
			installNasHkFlag: false, //true显示海康弹框
			add_device_class: true, //控制样式的标识
			bindCode: "",
			disappear_icon_flag: false, //移除服务弹框里面的，true选中，false未选中
			remoteWakeupStep: 1,
		};
	},
	methods: {
		closeClick: function () {
			let _that = this;
			_that.$emit("close");
		},
		showWakeupTips: function () {
			let _that = this;
			_that.$emit("showWakeupTips");
		},
		ignoreRemoteWakeupTips: function () {
			let _that = this;
			_that.$common.localStorage.setItem("ignoreRemoteWakeupTips", true);
			_that.wakeupClick();
		},
		wakeupClick: function () {
			let _that = this;
			_that.$emit("wakeupClick");
		},
	},
};
</script>

<style scoped lang="less">
.wakeup-success-wrap {
	width: 300px;
	height: 300px;
	text-align: center;
	background-color: #ffffff;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -150px;
	margin-top: -150px;
	border-radius: 5px;
	.close-btn {
		background-image: url(../assets/mall/exchange_alert_close.png);
		background-size: 100% 100%;
		width: 15px;
		height: 15px;
		position: absolute;
		right: 15px;
		top: 15px;
		cursor: pointer;
	}
	.close-btn:hover {
		opacity: 0.8;
	}
	.wakeup-success-icon {
		width: 58px;
		height: 58px;
		background-image: url(../assets/home/node/remote_open_icon.svg);
		background-size: 100% auto;
		margin: 0 auto;
		margin-top: 60px;
		margin-bottom: 30px;
	}
	.wakeup-success-title {
		font-size: 17px;
		font-weight: bolder;
		margin-top: 30px;
		text-align: center;
		color: #1a1a1a;
	}
	svg {
		margin-top: 20px;
		width: 60px;
		height: 60px;
	}
	.wakeup-success-tips {
		font-size: 12px;
		margin-top: 10px;
		text-align: center;
		color: #999999;
		span {
			color: #1f5de3;
			cursor: pointer;
		}
		span:hover {
			opacity: 0.8;
		}
	}
	.done-btn {
		background-color: #e5e5e5;
		width: 180px;
		height: 41px;
		line-height: 41px;
		border-radius: 102px;
		text-align: center;
		box-shadow: 0px 0px 8px 1px rgba(193, 193, 193, 0.6);
		background-color: #5186f9;
		color: #f4f4f4;
		margin: 40px auto 0 auto;
		cursor: pointer;
	}
	.done-btn:hover {
		opacity: 0.9;
	}
}
.message-tip {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
}
</style>
